import React from 'react';
import { DialogContent, DialogActions, Button } from '@material-ui/core';
import QRCode from 'qrcode.react';
import { Dialog, QRContainer } from './styles';

const QrCodeDialog: React.FC<{
  openQRCode: boolean;
  params: { key: string };
  closeQRCode(): void;
}> = ({ openQRCode, params, closeQRCode }) => {
  return (
    <Dialog 
      open={openQRCode}
      onClose={closeQRCode}
      maxWidth="xs"
      fullWidth
    >
      <div className="MuiDialogTitle-root">
        <h2>
          <i className="bx bx-qr" />
          {params ? params.key : ''}
        </h2>
      </div>
      <DialogContent dividers>
        <QRContainer>
          <QRCode 
            value={params ? params.key : '0'} 
            size={200}
            level="H"
            includeMargin={true}
          />
        </QRContainer>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={closeQRCode}
        >
          Close
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            // Copy to clipboard
            if (params?.key) {
              navigator.clipboard.writeText(params.key);
            }
            closeQRCode();
          }}
        >
          Copy & Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QrCodeDialog;